import React from 'react';

import { Button, Grid2 as Grid, styled, SxProps, Theme } from '@mui/material';

import { ExternalLinkIcon } from '../../../assets/icons';
import { MarkdownContentWithImage } from './markdown-content-with-image-description';

export const FlexibleContent = ({
  richtext,
  imageData,
  getAssetUrl,
  cta,
  markdownSx,
}: {
  richtext: {
    data: {
      childMarkdownRemark: {
        html: string;
        headings: {
          value: string;
          depth: number;
        }[];
      };
    };
  };
  imageData?: {
    image: React.ReactElement;
    alignImage: 'left' | 'right';
  };
  getAssetUrl: (url: string, assetsUrl?: string | undefined) => string;
  cta?: {
    text: string;
    url: string;
  } | null;
  markdownSx?: SxProps<Theme>;
}) => {
  const renderButton = () => {
    if (!cta) {
      return;
    }
    const linkIsExternal = cta.url?.startsWith('http');

    return (
      <Button
        variant="contained"
        color="primary"
        href={cta.url}
        target={linkIsExternal ? '_blank' : undefined}
        rel={linkIsExternal ? 'noreferrer' : undefined}
        startIcon={linkIsExternal ? <ExternalLinkIcon /> : undefined}
        style={{ marginTop: 'var(--spacer-l)' }}
      >
        {cta.text}
      </Button>
    );
  };

  if (imageData?.image) {
    return (
      <Grid
        container
        columns={2}
        columnSpacing="var(--gutter)"
        rowSpacing={0}
        style={{
          flexDirection:
            imageData?.alignImage === 'right' ? 'row-reverse' : undefined,
        }}
      >
        <ImageContainer size={{ xs: 2, sm: 1 }}>
          {imageData?.image}
        </ImageContainer>
        <Grid size={{ xs: 2, sm: 1 }}>
          <ImageDescriptionContainer
            html={richtext.data.childMarkdownRemark.html}
            getAssetUrl={getAssetUrl}
            sx={markdownSx}
          />
          {renderButton()}
        </Grid>
      </Grid>
    );
  } else {
    return (
      <>
        <TextContainer
          html={richtext.data.childMarkdownRemark.html}
          getAssetUrl={getAssetUrl}
          sx={markdownSx}
        />
        {renderButton()}
      </>
    );
  }
};

const ImageContainer = styled(Grid)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    marginBottom: '30px',
  },
}));

const TextContainer = styled(MarkdownContentWithImage)(({ theme }) => ({
  [theme.breakpoints.up(0)]: {
    margin: 0,
  },
}));

const ImageDescriptionContainer = styled(MarkdownContentWithImage)(
  ({ theme }) => ({
    h6: {
      [theme.breakpoints.up(0)]: {
        margin: 0,
      },
    },
  }),
);
